var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2752_1236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 9.30225C1 5.43625 4.13401 2.30225 8 2.30225C11.866 2.30225 15 5.43625 15 9.30225C15 9.49297 14.889 9.66625 14.7157 9.74595C14.5424 9.82565 14.3386 9.79719 14.1938 9.67302C13.746 9.28922 13.3692 9.01456 13.0607 8.83829C12.7424 8.65642 12.5437 8.60667 12.4398 8.60667C12.3358 8.60667 12.1371 8.65642 11.8187 8.83829C11.5103 9.01456 11.1335 9.28922 10.6857 9.67302C10.4919 9.83913 10.203 9.828 10.0225 9.64756C9.2865 8.91155 8.61411 8.60667 8 8.60667C7.38589 8.60667 6.7135 8.91155 5.97747 9.64756C5.79702 9.828 5.50807 9.83913 5.3143 9.67302C4.8665 9.28922 4.4897 9.01456 4.18124 8.83829C3.86287 8.65642 3.66421 8.60667 3.56025 8.60667C3.4563 8.60667 3.25763 8.65642 2.93927 8.83829C2.6308 9.01456 2.25401 9.28922 1.8062 9.67302C1.66139 9.79719 1.45758 9.82565 1.2843 9.74595C1.11103 9.66625 1 9.49297 1 9.30225ZM2.07168 8.23121C2.20412 8.1409 2.33181 8.06048 2.45467 7.99028C2.82693 7.77755 3.20379 7.62993 3.56025 7.62993C3.91672 7.62993 4.29358 7.77755 4.66584 7.99028C4.95514 8.15561 5.27124 8.3776 5.61299 8.65167C6.36194 7.99849 7.15876 7.62993 8 7.62993C8.84124 7.62993 9.63807 7.99849 10.387 8.65167C10.7288 8.3776 11.0448 8.15561 11.3341 7.99028C11.7064 7.77755 12.0833 7.62993 12.4398 7.62993C12.7962 7.62993 13.1731 7.77755 13.5453 7.99028C13.6682 8.06048 13.7959 8.1409 13.9283 8.23121C13.423 5.41561 10.961 3.27899 8 3.27899C5.03898 3.27899 2.57699 5.41561 2.07168 8.23121Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.92857 8C8.16526 8 8.35714 8.2043 8.35714 8.4563V12.8835C8.35714 13.5439 8.8712 14.0874 9.5 14.0874C10.1288 14.0874 10.6429 13.5439 10.6429 12.8835C10.6429 12.6315 10.8347 12.4272 11.0714 12.4272C11.3081 12.4272 11.5 12.6315 11.5 12.8835C11.5 14.057 10.5935 15 9.5 15C8.40646 15 7.5 14.057 7.5 12.8835V8.4563C7.5 8.2043 7.69189 8 7.92857 8Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9996 1C8.26931 1 8.48797 1.21865 8.48797 1.48837V2.7907C8.48797 3.06042 8.26931 3.27907 7.9996 3.27907C7.72989 3.27907 7.51123 3.06042 7.51123 2.7907V1.48837C7.51123 1.21865 7.72989 1 7.9996 1Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2752_1236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.4471926d23669daffd21cc1793b3645f.svg";
export { ForwardRef as ReactComponent };